
import { useState, useEffect } from "react";
import Config from "../Config";

import xmenu from '../menu.png'
import xmenu_black from '../menu_black.png'

import logo from '../logo.png'
import empty_user from '../empty_user.png'


function ParentMenuTop(props)
{
    const [tCounter, setTCounter] = useState(props.userData.max_session_sec);
    const [noticeReload, setNoticeReload] = useState(0);
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const showMenu = (e) => {
        props.mainView.changeMenuStatus(1);
    }
    
    const hideMenu = (e) => {
        props.mainView.changeMenuStatus(0);
    }

    const reqRefresh = () => {

  
        setTCounter( tCounter - 1 );        
        
                var b5 = tCounter % 10;


                if(b5 == 0  )
                {        
                            var dt = { 
                                'clock': tCounter,
                                'version': Config.app_version,
                             }

            
                            fetch( Config.url + '/rest_v1,refresh', {
                                method: 'POST', 
                                body: JSON.stringify(dt), 
                                headers: {
                                    'Content-Type': 'text/html',
                                    'X-API-KEY': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {                                           
                            
                                

                                if(res.ERROR != undefined )
                                {
                                    
                                    if(res.ERROR == 'logout' || res.ERROR == 'LOGOUT')
                                    {
                                        //props.mainView.logout();
                                        localStorage.clear();
                                        sessionStorage.clear();

                                        props.mainView.showDialog("Ups!", "Sesja została zakończona", "ok", (option)=>{

                                            document.location.href = "/?msg=logout";

                                        })
                                    }
                                }

                                if(res.status != null && res.status != undefined)
                                {


                                       if(   (res.status == 'ask_reload' || res.status == 'ASK_RELOAD') && noticeReload == 1 )
                                        {
                                            //zapytaj i przeładuj..
                                            setNoticeReload(1);
                                        }

                                        if(res.status == 'reload' || res.status == 'RELOAD' )
                                        {
                                            window.location.reload();
                                        }

                                        if(res.status == 'logout' || res.status == 'LOGOUT')
                                        {
                                             props.mainView.logout();
                                             window.location.reload();
                                        }

                                        if(res.status == 'OK' || res.status == 'ok' )
                                        {
                                            
                                        }


                                        if(res.status == 'VERSION' || res.status == 'version')
                                            {

                                                var ts = new Date() / 1000;

                                                var lastTs =  props.mainView.readFilter('version_app',  -1 );
                                                var diffTs = 0;

                                                if(lastTs > 0)
                                                {
                                                    diffTs =  parseFloat( ts) -  parseFloat(lastTs) ;
                                                }

                                                console.log(lastTs, ts, diffTs);

                                                if(diffTs  > 120 || diffTs == 0)
                                                {
                                                        props.mainView.writeFilter('version_app',ts );
                                                    
                                                        props.mainView.showDialog("Potwierdź", "Panel wymaga aktualizacji. Czy chcesz teraz przeładować stronę?", "yesno", (option)=>{
            
                                                            ///--------
                                                            if(option == "yes")  window.location.reload();
                                                            //--------
                                                    } );
                                              }


                                            }

                                    
                                }
                                
                            } )
                            .catch(err => {
                                console.log("Err " + err);
                            });                                    
                }//b5 = 0

   }


   //-------------------------------------------------------------
    if(window.internalID == null || window.internalID == undefined)
    {          
          window.internalID =  setInterval(reqRefresh, 1000 );
    }else
    {
        clearInterval( window.internalID );
        window.internalID =  setInterval(reqRefresh, 1000 );
    }

   //----------------------------------------------------------


   const changeProfile = (e) => {

        let type = e.target.getAttribute("atr-type");
        let typeId = e.target.getAttribute("atr-typeid");
        let newTab = e.target.getAttribute("atr-tab");

        var nx = false;
        if(newTab != undefined && newTab != null) nx = true;

        props.mainView.changeProfile(type, typeId, nx); //dz pl + id
    }

   //----------------------------------------------------------

   
   var choiseOption = null;

   var date = new Date(0);
   if(tCounter != undefined)date.setSeconds(tCounter); 
   var timeString = date.toISOString().substring(11, 19);

   var classDef = "";
   if(tCounter < 60)
   {
       classDef = "alert";
   }


   var pSeleted = "";
   var pSeletedId = "";
  

   //----------------------------------------------------------   
   if(props.userData.type == 'RODZIC')
   {
           //console.log(props.userData);
            
            for(var pi =0; pi<props.userData.dz.length; pi++ )
                {
                    if(props.userData.dz[pi]['id']  == props.userData.p_dziecko_id)
                    {    
                        var xnazwa = props.userData.dz[pi]['imie'] + " " +  props.userData.dz[pi]['nazwisko'];    
                        if(xnazwa.length > 20) xnazwa = xnazwa.substring(0,20) + "...";                  
                        pSeleted =  xnazwa ;                                                                 

                        pSeletedId = props.userData.dz[pi]['id'];
                    }
                }



                choiseOption =    <div className="mtop_item popup ">
                      {pSeleted}  [ZMIEŃ]


                      <div className="windows_popup">                         
                            <div className="windows_view">
                                    {
                                            
                                            props.userData.dz.map( (item, ix) => {

                                                    if(item.id == pSeletedId)
                                                    {

                                                        return (
                                                                <div className="pl_item pl_active" key={"p_" +ix }>
                                                                
                                                                    <div className="pl_img">
                                                                        <img src={ empty_user}   title={item.imie + " " + item.nazwisko} />
                                                                    </div>

                                                                    <div className="pl_title"   >
                                                                        {item.imie + " " + item.nazwisko},
                                                                        <br/>                                                                                                                                                                                               
                                                                    </div>                                                   
                                                                </div>
                                                        )  


                                                    }else{

                                                            return (
                                                                <div className="pl_item" key={"p_" +ix }>
                                                                    <div className="pl_img">
                                                                        <img src={ empty_user } className="pl_link" atr-type={"dz"} atr-typeid={item.id} onClick={changeProfile} title={item.imie + " " + item.nazwisko}  />
                                                                    </div>
                                                                    <div className="pl_title" >
                                                                        {item.imie + " " + item.nazwisko }        
                                                                        <br/>                                                              
                                                                        <span className="pl_link" atr-type={"dz"} atr-typeid={item.id} onClick={changeProfile} >
                                                                            pokaż tutaj
                                                                        </span>
                                                                        &nbsp;  &nbsp;  lub &nbsp; &nbsp; 
                                                                        <span className="pl_link" atr-type={"dz"} atr-typeid={item.id} atr-tab="true" onClick={changeProfile} >
                                                                            pokaż w nowej karcie
                                                                        </span>
                
                                                                        
                                                                    </div>                                                   
                                                                </div>
                                                            )

                                                    }

                                            })

                                    }
                            </div>
                      </div>



                </div>      
   }


   if(refreshView != props.userData.refreshView)
    {
        //props.userData.max_session_sec
        
        setRefreshView(props.userData.refreshView);
        setTCounter(props.userData.max_session_sec);
    }
    
  
    return (
        <div className="menu_top" >    
             

                {
                    props.mainView.menuVisible == 0 &&
                    <div className="menu_show_btn link_normal mobile_hide_now " onClick={showMenu}>
                        <img src={xmenu} className="img_white" />
                        <img src={xmenu_black} className="img_black" />
                        </div>
                }

                {
                    props.mainView.menuVisible == 1 &&
                    <div className="menu_show_btn link_normal mobile_hide_now" onClick={hideMenu}  >
                           <img src={xmenu} className="img_white" />
                           <img src={xmenu_black} className="img_black" />
                        </div>
                }


               {choiseOption} 

               <div className="mtop_item mobile_hide" title="Koniec sesji za">{props.userData.dic.toend}: <span className={classDef}   >{timeString} </span></div>

               &nbsp;

                
                <div className="mtop_item popup " title="Wyloguj z systemu">
                &nbsp; &nbsp;  {props.userData.name} {props.userData.last_name}  &nbsp; &nbsp;
                      <div className="windows_popup">                         
                         <div className="windows_view">
                                               <div className="pl_item">
                                                    <div className="pl_img pl_link " onClick={props.mainView.logout}>
                                                          {props.userData.dic.logout}
                                                    </div>                                                                                                      
                                                </div>

                                                <div className="pl_item">
                                                    <div className="pl_img pl_link " module="home" view="account" id="" onClick={props.mainView.quickGo}>
                                                         {props.userData.dic.account}
                                                    </div>                                                                                                      
                                                </div>
                         </div>
                      </div>
                </div>

                <div className="mtop_item mtop_lng " >
                         <span atr-p="en" className="link_normal" onClick={props.mainView.changeLang}> EN </span>
                        <span atr-p="pl" className="link_normal"  onClick={props.mainView.changeLang}> PL </span>
                        &nbsp; &nbsp;
                </div>  

                &nbsp;


        </div>
    )




}

export default ParentMenuTop;